import { useMuiTheme } from '@/config/theme/useMuiTheme';
import ThemeProvider from '@mui/system/ThemeProvider';
import { CssBaseline } from '@mui/material';
import { MuiTheme } from '@lemontaps/lib/types/api';

export default function LtThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme, globalStyles } = useMuiTheme();

  return (
    <ThemeProvider theme={theme as MuiTheme}>
      <CssBaseline />
      {globalStyles}
      {children}
    </ThemeProvider>
  );
}
